import { useState } from 'react'
import { message } from 'antd'

interface UseProcedureArchiveReturn {
  archiveProcedure: (procedureId: string) => Promise<void>
  unarchiveProcedure: (procedureId: string) => Promise<void>
  isArchiving: boolean
}

export const useProcedureArchive = (onSuccess?: () => void): UseProcedureArchiveReturn => {
  const [isArchiving, setIsArchiving] = useState(false)

  const archiveProcedure = async (procedureId: string): Promise<void> => {
    setIsArchiving(true)

    // Simulate API call
    return new Promise((resolve) => {
      setTimeout(() => {
        message.success('Procedure archived successfully')
        setIsArchiving(false)

        if (onSuccess) {
          onSuccess()
        }

        resolve()
      }, 500)
    })
  }

  const unarchiveProcedure = async (procedureId: string): Promise<void> => {
    setIsArchiving(true)

    // Simulate API call
    return new Promise((resolve) => {
      setTimeout(() => {
        message.success('Procedure restored successfully')
        setIsArchiving(false)

        if (onSuccess) {
          onSuccess()
        }

        resolve()
      }, 500)
    })
  }

  return {
    archiveProcedure,
    unarchiveProcedure,
    isArchiving
  }
}
